// SHER-459 — value shape + parsing for the operative report "Geste principal"
// field. The field stores a `{ procedure, procedureId }` object (procedure name
// for every display/PDF, catalog id for statistics), mirroring the ICD field's
// name+code shape. Kept dependency-free so the edit, read-only and PDF render
// paths can all parse the value from a single source of truth.

export interface SurgicalProcedureValue {
  /** Human-readable procedure name — what every display/PDF path shows. */
  procedure: string;
  /** Catalog reference (ServiceInvestigation id) — kept for statistics/links. */
  procedureId: number | null;
}

/**
 * Normalise a stored value into the procedure name. The value may arrive as:
 *  - the `{ procedure, procedureId }` object this field writes,
 *  - a JSON string of that object (after a DB round-trip),
 *  - a legacy plain string (the bare procedure name),
 *  - empty.
 */
export function parseSurgicalProcedureName(rawValue: any): string {
  if (!rawValue) {
    return '';
  }
  let value = rawValue;
  if (typeof value === 'string') {
    if (value.startsWith('{')) {
      try {
        value = JSON.parse(value);
      } catch (e) {
        return value; // legacy plain-string name
      }
    } else {
      return value; // legacy plain-string name
    }
  }
  if (value && typeof value === 'object') {
    return value.procedure || '';
  }
  return '';
}
